import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import { useImpactFormDisabled } from "app/routes/psp/management/useImpactReadOnly";
// import "./index.css";

function FormInput(props) {
  const { control } = useFormContext();
  const { name, label, required, errorobj, disabled, ...restProps } = props;
  const isDisabled = useImpactFormDisabled(disabled);

  let isError = false;
  let errorMessage = "";
  if (errorobj && errorobj.hasOwnProperty(name)) {
    isError = true;
    errorMessage = errorobj[name].message;
  }

  return (
    <Controller
      as={TextField}
      variant="outlined"
      size="small"
      name={name}
      control={control}
      defaultValue=""
      label={label}
      fullWidth={true}
      InputLabelProps={{
        className: required ? "required-label" : "",
        required: required || false,
      }}
      error={isError}
      helperText={errorMessage}
      disabled={isDisabled}
      {...restProps}
    />
  );
}

export default FormInput;
